import analytics from '@betterplace/product-analytics'
import { useEffect } from 'react'
export const useAnalytics = (active: boolean) => {
  useEffect(() => {
    if (analytics.isInitialized()) {
      active ? analytics.optIn() : analytics.optOut()
      return
    }
    if (active) {
      analytics.initialize({
        apiKey: process.env.POSTHOG_API_KEY || '',
        enable: !!process.env.ENABLE_POSTHOG || !!process.env.HONEYBADGER_ENV?.toLowerCase().includes('staging'),
        // (process.env.NODE_ENV === 'production' && process.env.RAILS_ENV !== 'test'),
      })
    }
  }, [active])
}
